import axios from 'axios';

// const baseUrlIdentificacionDigital = 'https://identificaciondigital.qa.api.hircasa.com/Incode'; 
// QA - LINK
const baseUrlIdentificacionDigital = process.env.VUE_APP_URL_IDENTIFICACION_DIGITAL; 

const embajadoresApi = axios.create({
  headers: {
    'Content-type': 'application/json',
  },
});

/* Prospecto */
export const obtenerProspectoRepresentanteLegal = async (prospectoId) => {
    const { data } = await embajadoresApi.get(`/api/Master/Prospecto/ObtenerProspectoRepresentanteLegal?prospectoId=${prospectoId}`);  
    return data.data;
}

export const obtenerDatosProspectoBuroCredito = async (prospectoId) => {
  const { data } = await embajadoresApi.get(`/api/Master/Prospecto/ObtenerDatosProspectoBuro?prospectoId=${prospectoId}`);
  return data.data;
}

export const enviarDatosProspectoBuroCredito = async (prospectoId) => {
  await embajadoresApi.post(`/api/Master/PreAutorizacion/GuardarConsultaAutorizacionBuroCredito?prospectoId=${prospectoId}`);
}

export const obtenerFlujoBuro = async () => {
  const { data } = await embajadoresApi.get(`/api/Master/PreAutorizacion/FlujoBuro`);
  return data.data;
}

export const motorDecision = async (prospectoId, usuarioId) => {
  const { data } = await embajadoresApi.post(`/api/Master/PreAutorizacion/MotorDecision?prospectoId=${prospectoId}&usuarioId=${usuarioId}`);
  return data;
}

export const ObtenerAutorizacionBuroApi = async (prospectoId) => {
  const { data }  = await embajadoresApi.get(`/api/Master/PreAutorizacion/VerificarAutorizacion?prospectoId=${prospectoId}`);
  return data;
}
/* Integración de expediente */
export const ProspectoTieneArchivoBuroCredito = async (prospectoId) => {
  const { data }  = await embajadoresApi.get(`/api/Master/IntegracionExpediente/TieneArchivoBuroCredito?prospectoId=${prospectoId}`);
  return data;
}

/* Sesiones Incode */
export const getSession = async (prospectoId ) => {
  const { data } =  await embajadoresApi.get(`${baseUrlIdentificacionDigital}/SesionIncode/${prospectoId}`);
  return data == '' ? null : data;
}
export const saveSession = async (session) => {
  await embajadoresApi.post(`${baseUrlIdentificacionDigital}/SesionIncode`, session);
}
export const updateSession =  async (prospectoId) => {
  await embajadoresApi.put(`${baseUrlIdentificacionDigital}/SesionIncode/${prospectoId}`);
}